/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format
/** Show a dimmer backdrop
   *
   *  Used to catch input when showing modals, context menus etc.
   *
   *  @example
   *  dimmer(function () {
   *       alert('You clicked the dimmer!');
   *  });
   *
   *  @param {function} fn - the function to call when the dimmer is clicked
   *  @param {bool} autohide - set to true to hide the dimmer when it's clicked
   *  @param {bool} transparent - set to true for the dimmer to be transparent
   *  @param {number} zIndex - the z index *offset*
   *  @param {number} parent - optional parent to add dimmer to
   *  @return {function} - A function that can be called to hide the dimmer
   */

import { isFn } from "./../core/highcharts-editor";
import {cr, ap, setStyle, on } from "./../core/highed.dom";

export default function(fn, autohide, transparent, zIndex, parent) {
  let dimmer = cr('div', 'highed-dimmer'),
    unbinder = false;

  ap(parent || document.body, dimmer);

  setStyle(dimmer, {
    opacity: 0.5,
    'pointer-events': 'auto',
    'z-index': 9999 + (zIndex || 0)
  });

  if (transparent) {
    setStyle(dimmer, {
      opacity: 0
    });
  }

  function hide() {
    setStyle(dimmer, {
      opacity: 0,
      'pointer-events': 'none'
    });

    if (isFn(unbinder)) {
      unbinder();
      unbinder = false;
    }

    window.setTimeout(function() {
      if (dimmer.parentNode) {
        dimmer.parentNode.removeChild(dimmer);
      }
    }, 300);
  }

  unbinder = on(dimmer, 'click', function(e) {
    if (isFn(fn)) {
      fn();
    }

    if (autohide) {
      hide();
    }
  });

  return hide;
};